import { Star } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
const testimonials = [{
  author: "Jan de Vries",
  quote: <>
        <span className="text-[#ffe838]">Zap</span><span className="text-[#70cf70]">GO!</span> made sure I always had a charged phone during my busy day. Highly recommended!
      </>,
  position: "End-user"
}, {
  author: "Café De Hoek",
  quote: <>
        Hosting a <span className="text-[#ffe838]">Zap</span><span className="text-[#70cf70]">GO!</span> station has brought more customers to our café and extra revenue.
      </>,
  position: "Venue Owner"
}];
export default function Testimonials() {
  return <section id="testimonials" className="bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-tight">
            Powered by Trust
          </h2>
          <p className="text-lg text-muted-foreground">
            See how <span className="text-[#ffe838]">Zap</span><span className="text-[#70cf70]">GO!</span> is keeping people connected and helping businesses grow across the Netherlands.
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
          {testimonials.map((testimonial, i) => <div key={i} data-index={i} className="break-inside-avoid pb-6">
              <Card className="bg-card/40 backdrop-blur-xl border-border/50 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_0_30px_-5px_var(--color-primary)] hover:border-primary/40 group h-full flex flex-col">
                <CardHeader className="pb-4">
                  <div className="flex gap-1 mb-2">
                    {[...Array(5)].map((_, starIdx) => <Star key={starIdx} className="size-4 fill-primary text-primary drop-shadow-[0_0_8px_var(--color-primary)]" />)}
                  </div>
                </CardHeader>
                <CardContent className="pb-6 flex-grow">
                  <p className="text-foreground/90 text-lg leading-relaxed font-medium">
                    "{testimonial.quote}"
                  </p>
                </CardContent>
                <CardFooter className="border-t border-border/10 pt-4 mt-auto">
                  <div>
                    <p className="font-semibold text-foreground group-hover:text-primary transition-colors">
                      {testimonial.author}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {testimonial.position}
                    </p>
                  </div>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}